import { render, staticRenderFns } from "./ProjectsView.vue?vue&type=template&id=1ddad68a&scoped=true"
import script from "./ProjectsView.vue?vue&type=script&lang=ts"
export * from "./ProjectsView.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsView.vue?vue&type=style&index=0&id=1ddad68a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddad68a",
  null
  
)

export default component.exports